import { getJSON, STORE_HOST, get } from '../ultile';
import { gameIdTransform } from '../web/webStore';
import { times } from '../../utiles/numberPrecision';
import globalConfig from '../../utiles/globalConfig';
import { ACTIVITY_COUPON_CONFIG } from '../config/activityCoupon';
const mainHost = globalConfig.getMainHost();

export const SET_GAME_COUPON_ENTRY_SHOW_STATUS =
  'set_game_coupon_entry_show_status';
export const SET_GAME_COUPON_POPUP_SHOW_STATUS =
  'set_game_coupon_popup_show_status';
export const SET_VIP_COUPON_SHOW_STATUS = 'set_vip_coupon_show_status';
export const SET_GAME_COUPON_ITEM_USE_BTN = 'set_game_coupon_item_use_btn';
export const UPDATE_GAME_ENABLE_COUPON_LIST = 'update_game_enable_coupon_list';
export const UPDATE_GAME_DISABLE_COUPON_LIST =
  'update_game_disable_coupon_list';
export const UPDATE_GAME_EXPIRE_COUPON_LIST = 'update_game_expire_coupon_list';
export const UPDATE_VIP_COUPON_LIST = 'update_vip_coupon_list';
export const UPDATE_VIP_LEVEL = 'update_vip_level';
export const UPDATE_VIP_NEXT_LEVEL_POINT = 'update_vip_next_level_point';
export const UPDATE_VIP_SUM_POINT = 'update_vip_sum_point';
export const UPDATE_GAME_ACTIVE_COUPON_ID = 'update_game_active_coupon_id';
export const LOAD_GAME_COUPON_LIST = 'load_game_coupon_list';

export const SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS =
  'set_paytype_coupon_popup_show_status';
export const UPDATE_PAYTYPE_ENABLE_COUPON_LIST =
  'update_paytype_enable_coupon_list';
export const UPDATE_PAYTYPE_DISABLE_COUPON_LIST =
  'update_paytype_disable_coupon_list';
export const UPDATE_PAYTYPE_EXPIRE_COUPON_LIST =
  'update_paytype_expire_coupon_list';
export const UPDATE_PAYTYPE_ACTIVE_COUPON_ID =
  'update_paytype_active_coupon_id';
export const LOAD_PAYTYPE_COUPON_LIST = 'load_paytype_coupon_list';
export const LOAD_VIP_COUPON_INFO = 'load_vip_coupon_info';
export const UPDATE_ACTIVITY_COUPON_LIST = 'update_activity_coupon_list';
export const SET_ACTIVITY_COUPON_SHOW_STATUS =
  'set_activity_coupon_show_status';
export const LOAD_ACTIVITY_COUPON_INFO = 'load_activity_coupon_info';

const PAYTYPE_COUPON_LIST_ACTION = 'coupon/get_pay_coupon_list';
const VIP_COUPON_INFO_ACTION = 'coupon/send_coupons';
const GAME_COUPON_LIST_ACTION = 'coupon/get_coupon_list';

export default {
  state: {
    isShowPaytypePopupCoupon: false, //是否显示渠道优惠券弹窗
    paytypeEnableCouponList: [], //渠道优惠券列表 - 可用
    paytypeDisableCouponList: [], //渠道优惠券列表 - 不可用：无效
    paytypeExpireCouponList: [], //渠道优惠券列表 - 不可用：过期
    paytypeActiveCouponId: '', //渠道选中的优惠券Id

    isShowGameItemUseBtn: false, // 是否显示优惠券的立即使用按钮
    isShowGameCouponEntry: false, // 是否显示游戏优惠券入口
    isShowGameCouponPopup: false, //是否显示游戏优惠券列表
    isShowVipCouponPopup: false, //是否展示VIP积分优惠券弹窗
    gameCouponEnableList: [], // 游戏优惠券列表 - 可用
    gameCouponDisableList: [], // 游戏优惠券列表 - 不可用：无效
    gameCouponExpireList: [], // 游戏优惠券列表 - 不可用：过期
    gameActiveCouponId: '', // 游戏选中的优惠券Id
    vipSumPoint: 0, // 用户积分
    vipLevel: 0, // 用户VIP等级
    vipNextLevelPoint: 0, //VIP满足下一等级的积分
    vipCouponList: [], // VIP发放的优惠券列表
    activityCouponList: [], // 活动优惠券
    isShowActivityCouponPopup: false
  },
  getters: {
    activePaytypeCouponInfo(state) {
      let index = -1;
      for (let i = 0; i < state.paytypeEnableCouponList.length; i++) {
        if (
          state.paytypeEnableCouponList[i].COUPON_ID ==
          state.paytypeActiveCouponId
        ) {
          index = i;
          break;
        }
      }
      return index !== -1 ? state.paytypeEnableCouponList[index] : [];
    },
    activePaytypeCouponFullReductType(_state, getters) {
      return +getters.activePaytypeCouponInfo.TYPE === 0;
    },
    activePaytypeCouponDiscountType(_state, getters) {
      return +getters.activePaytypeCouponInfo.TYPE === 1;
    },
    activePaytypeCouponReductPrice(_state, getters) {
      return +getters.activePaytypeCouponInfo.REDUCTION_MONEY || 0;
    },
    activePaytypeCouponReductionName(_state, getters) {
      return (
        '- ' +
        getters.activePaytypeCouponInfo.REDUCTION_MONEY +
        ' ' +
        getters.activePaytypeCouponInfo?.CURRENCY
      );
    },
    activePaytypeCouponDiscountName(_state, getters) {
      return times(getters.activePaytypeCouponInfo.DISCOUNT, 100) + '%OFF';
    },
    activeGameCouponProductList: state => {
      let res = [];
      let activeCoupon = state.gameCouponEnableList.filter(item => {
        return item.COUPON_ID == state.gameActiveCouponId;
      });
      activeCoupon &&
        activeCoupon.length &&
        activeCoupon[0].PRODUCT_LIST &&
        activeCoupon[0].PRODUCT_LIST.forEach(productItem => {
          res.push(productItem);
        });
      return res;
    }
  },
  mutations: {
    [SET_GAME_COUPON_ITEM_USE_BTN](state, status) {
      state.isShowGameItemUseBtn = status;
    },
    [SET_GAME_COUPON_ENTRY_SHOW_STATUS](state, status) {
      state.isShowGameCouponEntry = status;
    },
    [SET_GAME_COUPON_POPUP_SHOW_STATUS](state, status) {
      state.isShowGameCouponPopup = status;
    },
    [SET_VIP_COUPON_SHOW_STATUS](state, status) {
      state.isShowVipCouponPopup = status;
    },
    [UPDATE_VIP_SUM_POINT](state, status) {
      state.vipSumPoint = status;
    },
    [UPDATE_VIP_LEVEL](state, status) {
      state.vipLevel = status;
    },
    [UPDATE_VIP_NEXT_LEVEL_POINT](state, status) {
      state.vipNextLevelPoint = status;
    },
    [UPDATE_VIP_COUPON_LIST](state, status) {
      state.vipCouponList = status;
    },
    [UPDATE_GAME_ENABLE_COUPON_LIST](state, list) {
      state.gameCouponEnableList = list;
    },
    [UPDATE_GAME_DISABLE_COUPON_LIST](state, list) {
      state.gameCouponDisableList = list;
    },
    [UPDATE_GAME_EXPIRE_COUPON_LIST](state, list) {
      state.gameCouponExpireList = list;
    },
    [UPDATE_GAME_ACTIVE_COUPON_ID](state, id) {
      state.gameActiveCouponId = id;
    },
    [SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS](state, status) {
      state.isShowPaytypePopupCoupon = status;
    },
    [UPDATE_PAYTYPE_ENABLE_COUPON_LIST](state, list) {
      state.paytypeEnableCouponList = list;
    },
    [UPDATE_PAYTYPE_DISABLE_COUPON_LIST](state, list) {
      state.paytypeDisableCouponList = list;
    },
    [UPDATE_PAYTYPE_EXPIRE_COUPON_LIST](state, list) {
      state.paytypeExpireCouponList = list;
    },
    [UPDATE_PAYTYPE_ACTIVE_COUPON_ID](state, id) {
      state.paytypeActiveCouponId = id;
    },
    [UPDATE_ACTIVITY_COUPON_LIST](state, status) {
      state.activityCouponList = status;
    },
    [SET_ACTIVITY_COUPON_SHOW_STATUS](state, status) {
      state.isShowActivityCouponPopup = status;
    }
  },
  actions: {
    [LOAD_PAYTYPE_COUPON_LIST]({ commit }, param) {
      return new Promise((resolve, reject) => {
        getJSON(
          STORE_HOST + PAYTYPE_COUPON_LIST_ACTION,
          gameIdTransform(param)
        ).then(({ errmsg, data }) => {
          if (!errmsg) {
            data.enable &&
              commit(UPDATE_PAYTYPE_ENABLE_COUPON_LIST, data.enable);
            data.disable &&
              commit(UPDATE_PAYTYPE_DISABLE_COUPON_LIST, data.disable);
            data.expire &&
              commit(UPDATE_PAYTYPE_EXPIRE_COUPON_LIST, data.expire);
            resolve(true);
          } else {
            reject(errmsg);
          }
        });
      });
    },
    [LOAD_GAME_COUPON_LIST]({ commit }, param) {
      return new Promise((resolve, reject) => {
        getJSON(
          STORE_HOST + GAME_COUPON_LIST_ACTION,
          gameIdTransform(param)
        ).then(({ errmsg, data }) => {
          if (!errmsg) {
            data.enable &&
              data.enable.length &&
              commit(UPDATE_GAME_ENABLE_COUPON_LIST, data.enable);
            data.disable &&
              data.disable.length &&
              commit(UPDATE_GAME_DISABLE_COUPON_LIST, data.disable);
            data.expire &&
              data.expire.length &&
              commit(UPDATE_GAME_EXPIRE_COUPON_LIST, data.expire);
            commit(SET_GAME_COUPON_ENTRY_SHOW_STATUS, true);
            resolve(true);
          } else {
            reject(errmsg);
          }
        });
      });
    },
    [LOAD_VIP_COUPON_INFO]({ commit }, param) {
      return new Promise((resolve, reject) => {
        get(
          STORE_HOST + VIP_COUPON_INFO_ACTION,
          gameIdTransform(param),
          { catchError: true, config: { withCredentials: true } }
        ).then(({ errmsg, data }) => {
          if (!errmsg) {
            commit(UPDATE_VIP_LEVEL, data.vip_lv);
            commit(UPDATE_VIP_SUM_POINT, data.sum_points);
            commit(UPDATE_VIP_NEXT_LEVEL_POINT, data.next_lv_points);
            if (data.send_coupons && data.send_coupons.length) {
              commit(UPDATE_VIP_COUPON_LIST, data.send_coupons);
              commit(SET_VIP_COUPON_SHOW_STATUS, true);
            }
            resolve(true);
          } else {
            reject(errmsg);
          }
        }).catch(error => {
          reject(error?.errmsg ? new Error(error.errmsg) : error);
        });
      });
    },
    // 获取活动优惠券发奖列表
    [LOAD_ACTIVITY_COUPON_INFO]({ commit }, param) {
      return new Promise(_resolve => {
        let gameId = param.gameId || '';
        const ACTIVITY_COUPON_INFO_ACTION = `//gactivityapi.${mainHost}/activity/execute?name=${ACTIVITY_COUPON_CONFIG[gameId].sendCouponApi.name}&action=${ACTIVITY_COUPON_CONFIG[gameId].sendCouponApi.action}`;
        getJSON(ACTIVITY_COUPON_INFO_ACTION, gameIdTransform(param)).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              if (data.enable && data.enable.length) {
                commit(UPDATE_ACTIVITY_COUPON_LIST, data.enable);
                commit(SET_ACTIVITY_COUPON_SHOW_STATUS, true);
              }
            }
          }
        );
      });
    }
  }
};
